import { icons } from '../icons';
import { resolveText } from '../../i18n/resolveText';
export function renderContacts(block) {
    const section = document.createElement('section');
    section.className = 'contacts';
    const phonesHtml = block.phones
        .map((phone) => `
      <a href="${phone.href}" class="contact-row__phone">
        <span class="contact-row__name">${resolveText(phone.name)}</span>
        <span class="contact-row__primary">${phone.phone}</span>
      </a>`)
        .join('');
    section.innerHTML = `
    <h2 class="contacts__title">${resolveText(block.title)}</h2>
    <div class="contacts__list">
      <div class="contact-row">
        <span class="contact-row__icon">${icons.location}</span>
        <a href="${block.addressHref}" target="_blank" rel="noopener" class="contact-row__text">
          <span class="contact-row__address">${resolveText(block.address)}</span>
          <span class="contact-row__secondary">${resolveText(block.addressNote)}</span>
        </a>
      </div>
      <div class="contact-row">
        <span class="contact-row__icon">${icons.phone}</span>
        <div class="contact-row__phones">${phonesHtml}</div>
      </div>
      <div class="contact-row">
        <span class="contact-row__icon">${icons.mail}</span>
        <a href="mailto:${block.email}" class="contact-row__primary contact-row__email">${block.email}</a>
      </div>
    </div>
  `;
    return section;
}
